module.exports = __webpack_public_path__ + "static/media/sort-icon-white.c2b12ce3.svg";